import { AnchorHTMLAttributes, PropsWithChildren, forwardRef } from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import Link from 'next/link';

export const buttonVariants = cva(
  'group text-center flex justify-center items-center cursor-pointer leading-4 tracking-[2px] transition ease-in-out duration-200 outline-none',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-white hover:bg-white hover:text-graphite border-2 border-primary',
        unanimated: 'bg-primary text-white border-2 border-primary',
        outline:
          'border-2 border-primary text-primary hover:text-white hover:bg-primary',
        'white-outlined':
          'border-2 border-primary text-primary hover:text-white hover:bg-primary bg-white',
      },
      size: {
        default:
          'w-full h-[64px] uppercase text-sm font-semibold py-[10px] px-[30px]',
        slim: 'w-full uppercase text-sm font-semibold py-4 px-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

type Props = AnchorHTMLAttributes<HTMLAnchorElement> &
  PropsWithChildren &
  VariantProps<typeof buttonVariants> & {
    className?: string;
    isLoading?: boolean;
    scroll?: boolean;
  };

// eslint-disable-next-line react/display-name
const RedirectButton = forwardRef<HTMLAnchorElement, Props>(
  ({ children, variant, size, className, href, ...props }, forwardedRef) => {
    return (
      <Link
        className={cn(buttonVariants({ variant, size, className }))}
        href={href || ''}
        {...props}
        ref={forwardedRef}>
        {children}
      </Link>
    );
  },
);

export default RedirectButton;
